import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    public router: Router,
    private toasterService: ToastService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) { }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        // Handle the error here

        let errorMessages = [];
        switch (error.status) {
          case 400:
            if (error.error.error) {
              this.toasterService.error(error.error.error);
            }
            break;
          case 401:
            // sessionStorage.clear();
            // this.router.navigate(['/']);
            // window.location.reload()
            break;
          case 403:

            break;
          case 404:

            break;
          case 422:
            if (error.error.error) {
              //use toaster
            } else {
              for (let iRow in error.error.errors) {
                for (let jRow in error.error.errors[iRow]) {
                  errorMessages.push(error.error.errors[iRow][jRow])
                }
              }
              //open error dialog box
            }
            break;
          case 500:

            break;
          default:

            break;
        }
        //throw error as per requirement
        return throwError(error);
      })
    );
  }
}
